import { render, staticRenderFns } from "./CoursewareTextBlock.vue?vue&type=template&id=efe81cca&scoped=true&"
import script from "./CoursewareTextBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareTextBlock.vue?vue&type=style&index=0&id=efe81cca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe81cca",
  null
  
)

export default component.exports